/* CHAT THREAD */
.chat-thread {
  display: flex;
  width: 100%;
  height: 100%;
  container-type: size;
}

.viewport {
  display: flex;
  flex: 1;
  flex-flow: column nowrap;
  overflow: hidden auto;
  scroll-behavior: smooth;
  /* scroll-snap-type: block proximity; */
  /* padding: 1rem; */
  scrollbar-color: var(--mantine-color-dark-5) transparent;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  /* scroll-padding: 1rem; */
}

.viewport-messages {
  display: flex;
  flex: 1;
  flex-flow: column nowrap;
  anchor-name: --viewport-messages;
}

.viewport-footer {
  position: sticky;
  bottom: 0;
  display: grid;
  margin-top: auto;
  border-top: 1px solid var(--mantine-color-dark-4);
  backdrop-filter: blur(var(--mantine-spacing-sm));
  anchor-name: --viewport-footer;
}

.scroll-to-bottom {
  position: absolute;
  top: -1rem;
  left: 50%;
  translate: -50% -100%;
}

.message-parts {
  display: flex;
  flex-flow: column nowrap;
  row-gap: calc(var(--mantine-spacing-xs) * 0.5);
  align-items: flex-start;
}

/* CHAT MESSAGES */
.message-container {
  --transition-offset: var(--mantine-spacing-xl);
  position: relative;
  padding: var(--mantine-spacing-md);
  padding-block-end: 0;
  border-radius: inherit;

  &:last-child {
    padding-block-end: 3rem;
  }

  &[data-role='assistant'] {
    --glint-color: var(--mantine-color-cyan-5);
    /* margin-bottom: calc(var(--mantine-spacing-lg) * 2); */
    opacity: var(--transition);
    /* translate: calc(-1 * var(--transition-offset) + var(--transition-offset) * var(--transition)) 0; */
  }

  &[data-role='user'] {
    --glint-color: var(--mantine-color-indigo-5);
    opacity: var(--transition);
    translate: calc(var(--transition-offset) - var(--transition-offset) * var(--transition)) 0;

    .content-wrapper {
      display: grid;
      grid-template-columns: minmax(72px, 1fr) auto;

      .user-action-bar {
        grid-row: 1;
        grid-column: 1;
        align-self: center;
        justify-self: end;
        margin-right: var(--mantine-spacing-sm);
      }

      & > div:first-child {
        grid-row: 1;
        grid-column: 2;
        transform-origin: bottom right;
      }
    }
  }
}

.timestamp {
  align-self: flex-end;
  font-size: var(--mantine-font-size-xs);
  opacity: 0.7;
}

.assistant-footer {
  position: absolute;
  z-index: 10;
}

.edit-form {
  display: flex;
  flex-flow: column nowrap;
  gap: var(--mantine-spacing-xs);
  width: 40dvw;
}

.edit-actions {
  display: flex;
  gap: var(--mantine-spacing-sm);
  justify-content: flex-end;
}

.edit-composer {
  padding: var(--mantine-spacing-xs);
  resize: none;
  background: transparent;
  border: 1px solid var(--mantine-color-dark-4);
  border-radius: var(--mantine-radius-xs);
  &:focus {
    outline: none;
    box-shadow: 0 0 0 4px alpha(var(--mantine-color-dark-4), 0.3);
  }
}
